/**
 * Generic functionality to parse and build urls
 */
define(function (require) {
    "use strict";

    if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }

    var CoreUtils = require("CoreUtils");

    var KEYS = {
            OPTIONS: "{options}",
            MERGE: "merge",
            OVERRIDE: "override",
            FIRST: "first"
        },
        currentPath,
        location = window ? window.location : document.location,
        ver = "1.0.1";

    /**
     * Analyzed the current location and caches it since we are a SPA
     */
    function _setCurrentPath() {
        if (!currentPath) {//Cache instead of continually looking this up....
            currentPath = location.origin + location.pathname;
            currentPath = currentPath.substring(0, currentPath.lastIndexOf("/") + 1);
        }
    }

    /**
     * Returns the window location with trailing options (with or without the last "/" )
     * @param options
     * @returns {string|*}
     */
    function getWindowLocation(options) {
        var removeTrailing = options && options.removeTrailing;
        _setCurrentPath();
        return removeTrailing ? currentPath.substring(0, currentPath.length - 1) : currentPath;
    }

    /**
     * Breaks down URLs with a regex and returns the parts
     * @param url
     * @returns {{href: *, host: (*|string), hostname: (*|string), port: (*|string), pathname: string, protocol: *, hash: (*|string), search: (*|string), origin: string}}
     */
    function getUrlParts(url) {

        var urlParseRegEx = new RegExp(/((?:http|ftp|ws){0,1}s{0,1}\:){0,1}(?:\/\/){0,1}([\d{}a-z\.-]*)?\:{0,1}(\d+){0,1}([^#?]+){0,1}([$\?][\S+][^#]+){0,1}([#\S+]+){0,1}/ig),
            urlPartMatches;
        /*
         Parts mapping:
         0 - Complete url
         1 - protocol
         2 - host
         3 - port
         4 - pathname
         5 - query string
         6 - hash
         */

        if (typeof url === 'string') {
            urlPartMatches = urlParseRegEx.exec(url);
        } else {
            urlPartMatches = [];
        }

        return {
            href: url,
            protocol: urlPartMatches[1] || "",
            host: (urlPartMatches[2] || "") + (urlPartMatches[3] ? ":" + urlPartMatches[3] : ""),
            hostname: urlPartMatches[2] || "",
            port: urlPartMatches[3] || "",
            pathname: urlPartMatches[4] || "",
            search: urlPartMatches[5] || "",
            hash: urlPartMatches[6] || "",
            origin: (urlPartMatches[1] ? urlPartMatches[1] + "//" : "") + (urlPartMatches[2] || "") + (urlPartMatches[3] ? ":" + urlPartMatches[3] : "")
        };
    }

    /**
     * Mustaches the url and replaces values
     * @param url
     * @param map
     * @returns {*}
     * @private
     */
    function _replaceMappings(url, map) {
        var partMappedValue;

        for (var key in map) { //function (value, key) {
            if (map.hasOwnProperty(key)) {
                partMappedValue = null;
                if (KEYS.OPTIONS !== key && typeof map[key] !== null) {
                    url = url.replace(new RegExp("{" + key + "}", "g"), map[key]);
                }
            }
        }
        return url;
    }

    /**
     * Prefixes the protocol to the URL
     * @param url
     * @returns {*}
     * @private
     */
    function _fixPartialUrl(url) {
        var parts,
            urlPrefix,
            protocol = location.protocol;

        parts = getUrlParts(url);

        if (url && !parts.protocol) {

            if(!parts.hostname){
                urlPrefix = location.origin;
            }else if (url.indexOf("//") !== 0) {
                urlPrefix = protocol + "//";
            }
            return urlPrefix + url;
        } else {
            return url;
        }
    }

    /**
     * Builds the correct url from the resource
     * It does the following:
     * Get the url string from the resource
     * replace parameters on the URL from configuration or LEConfig
     * add the version
     * prefixes the protocol if it is missing
     * @param url
     * @param config
     * @param options
     * @param options.fixPartialUrl
     */
    function getUrl(url, config, options) {
        options = options || {};
        options.fixPartialUrl = 'fixPartialUrl' in options ? options.fixPartialUrl : true;

        var params;

        if (typeof url === 'string') {//Resource is either an invoked function or an object
            params = CoreUtils.clone(config);
            url = _replaceMappings(url, params);
            if (options.fixPartialUrl) {
                url = _fixPartialUrl(url);
            }
        }

        return url;
    }

    /**
     * Checks if the url is the same as the page
     * @param url
     * @param url2
     * @returns {boolean}
     */
    function isSameOrigin(url, url2) {
        var parts = getUrlParts(url),
            parts2 = url2 ? getUrlParts(url2) : location;

        return parts.hostname == parts2.hostname &&
            parts.port == parts2.port &&
            parts.protocol == parts2.protocol;
    }

    return {
        getWindowLocation: getWindowLocation,
        getUrlParts: getUrlParts,
        getUrl: getUrl,
        isSameOrigin: isSameOrigin,
        version: function () {
            return ver;
        }
    };
});
